import { Component, input, linkedSignal, output } from '@angular/core';
import { AwareHttpRequest, IAwareCollection } from '@appbolaget/aware-http';
import { Observable } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { PaginatorDumbComponent } from './paginator-dumb.component';

@Component({
    selector: 'app-collection-paginator',
    template: '@if (collection()) {<app-paginator-dumb [collection]="collection()" (page)="goTo($event)"></app-paginator-dumb>}',
    imports: [MatButtonModule, MatIconModule, PaginatorDumbComponent],
})
export class AwareCollectionPaginatorComponent {
    readonly request = input.required<AwareHttpRequest>();
    readonly requestSignal = linkedSignal(this.request);
    readonly collection = input.required<IAwareCollection<any>>();
    readonly observable = input<Observable<any>>(undefined);

    readonly pageChange = output<AwareHttpRequest>();

    constructor() {}

    goTo(page: number) {
        this.requestSignal.set(this.requestSignal().page(page));

        this.pageChange.emit(this.requestSignal());
    }
}
